// Why this file exists:
// Because @equipmentshare/auth0-react does not provide a way to access the Auth0 user identity outside of hooks,
// this file is used to cache the Auth0 user identity
// and provide a way to access it throughout the application, NOT JUST IN HOOKS.
import { useAuth0, type Auth0ContextInterface, type Identity } from '@equipmentshare/auth0-react'

export let auth0Cache: Auth0ContextInterface
export let auth0UserIdentity: Identity

export const cacheAuthUserIdentity = ( identity: Identity ) => auth0UserIdentity = identity
export const getAuthUserIdentity = (): Identity => auth0UserIdentity
export const useAuth0Cache = () => {
	auth0Cache = useAuth0<Auth0ContextInterface>()
}
